module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12 align-left footer-bottom"
  }, [_vm._v("\n  Copyright \n  "), _c('span', [_c('router-link', {
    staticClass: "no-link",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("©")])], 1), _vm._v("\n     "), _c('a', {
    attrs: {
      "href": "https://cubeek.net"
    }
  }, [_vm._v("Jakub Stonavský")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Oldtimers Garage")]), _vm._v(" 2018"), _c('br'), _vm._v("\n  All rights reserved.\n  "), _c('api-check')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d4fd6aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/FooterCopyleft.vue
// module id = 1205
// module chunks = 1